<template>
  <section>
    <h2>Types</h2>
    <dl>
      <dt>Concept Scheme</dt>
      <dd>A concept lists that can be used as values in codelists.</dd>
      <dt>Concept</dt>
      <dd>Member of concept scheme.</dd>
      <dt>Property</dt>
      <dd>This document can be used as a property.</dd>
      <dt>Class</dt>
      <dd>This document can be used as a class/type for other documents.</dd>
      <dt>Template</dt>
      <dd>This document can be used as a template for new documents.</dd>
    </dl>
  </section>
</template>

<script>
export default {
  "name": "AboutTypes",
};
</script>
